import * as styles from './MenuSection.module.css'

function MenuSection({ children, className = styles.MenuSection }) {
  return <div className={className}>{children}</div>
}

export default MenuSection
